import http from "./http";
import config from "./config";
import moment from "moment";
import { CircularJSON } from "../utils";

export default function sendError(state = { login: {} }, action, type) {
   const url = `${config.baseUrl}Error/PostError`;

   try {
      let data = {
         application: "IBMS web",
         host: window.location.host,
         type: type,
         stack: action.payload.stackTrace || action.payload.stack || "",
         message: action.payload.message || JSON.stringify(action.payload),
         user: state.login.currentDetails ? state.login.currentDetails.userName || "nobody" : "nobody",
         timeLocal: moment().toISOString(),
         // reduxState: CircularJSON.stringify(state)
      };

      //dont send http errors
      if (data.message !== "HTTP Cancelled" && !data.message.includes("HTTP Error") && !data.stack.includes("XMLHttpRequest.xhr.onreadystatechange")) {
         return http({ url, method: "POST", data })
            .then(data => data)
            .catch(error => error);
      }
   } catch (e) {
      console.log(e);
   }
}



// WEBPACK FOOTER //
// ./src/boot/sendError.js